import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ExperienceCard from "@/components/ExperienceCard";

export default function Favorites() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/login"); return; }
    api.get("/favorites/mine").then((r) => setItems(r.data));
  }, [user, loading, navigate]);

  if (!user) return null;
  return (
    <div className="min-h-screen bg-canvas">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <div className="overline">Saved</div>
        <h1 className="font-serif text-4xl md:text-5xl mt-1 mb-10">Your favorites</h1>
        {items.length === 0 ? (
          <div className="text-muted2" data-testid="no-favorites">Nothing saved yet. Tap the heart on any experience.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {items.map((e) => <ExperienceCard key={e.id} exp={e} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
